import * as React from "react"
import colors from "theme/colors"

const SvgComponent = ({
  color = colors.cherryRed,
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  const w = 30
  const h = 30
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={w}
      height={h}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.56 6.903c1.317 0 2.788 1.339 3.226 2.7.483 1.333.161 2.686-.886 3.77-.204.197.458 1.519 1.61 2.779 1.193 1.305 2.385 1.994 2.641 1.73.83-.944 2.06-1.338 3.24-1.012 1.48.361 2.936 1.894 3.014 3.43 0 .882-.433 1.586-1.32 2.509l-.51.52c-.989.95-2.695.807-4.537.092-4.149-1.63-7.877-5.588-9.493-10-.698-1.927-.817-3.687.187-4.725.078-.073.16-.154.264-.26.05-.05.24-.248.284-.294.836-.857 1.428-1.24 2.28-1.24Zm0 .902c-.554 0-.982.277-1.666.978l-.285.295a7.71 7.71 0 0 1-.277.273c-.654.676-.555 2.14.028 3.75 1.53 4.174 5.076 7.94 8.985 9.475 1.547.6 2.982.722 3.625.104.067-.07.403-.41.497-.508.735-.764 1.066-1.303 1.067-1.848-.055-1.079-1.215-2.3-2.354-2.578-.875-.242-1.77.045-2.398.758-.819.848-2.362-.044-3.906-1.732-1.514-1.656-2.343-3.313-1.582-4.048.801-.83 1.035-1.812.67-2.82-.334-1.036-1.5-2.099-2.405-2.099ZM15.59 6c4.02 0 7.28 3.287 7.406 7.423l.004.25h-.872c0-3.675-2.796-6.642-6.308-6.766l-.23-.004V6Zm0 3.61c2.109 0 3.817 1.696 3.918 3.858l.005.204h-.872c0-1.698-1.265-3.062-2.877-3.154l-.174-.005V9.61Z"
        fill={color}
      />
    </svg>
  )
}

export default SvgComponent
